import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'

import { AppRoutes } from '@percent/product-nomination-form/routing/AppRoutes'
import { reportWebVitals } from '@percent/utility'
import { EnvironmentOverlay } from '@percent/shared/environment-overlay'
import { AppProviders } from '@percent/product-nomination-form/providers/AppProviders'

import './styles.scss'

if (process.env.NX_PUBLIC_USE_SENTRY_LOGGER === 'true') {
  Sentry.init({
    dsn: process.env.NX_PUBLIC_SENTRY_DSN,
    environment: process.env.NX_PUBLIC_REACT_APP_ENV,
    autoSessionTracking: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.33,
  })
}

const container = document.getElementById('root')

const root = createRoot(container!)

function App() {
  return (
    <StrictMode>
      <AppProviders>
        <EnvironmentOverlay />
        <AppRoutes />
      </AppProviders>
    </StrictMode>
  )
}

root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
